/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["player-controls{display:flex;align-items:center;padding:0 15px;height:65px;background-color:#23232c;color:#fff;border-top:1px solid rgba(255,255,255,.12);position:relative}player-controls button:hover{color:#c2c2ca}player-controls .lyrics{color:#c2c2ca;font-size:1.3rem;font-weight:500;margin:0 35px 0 15px}player-controls .player-action{color:#c2c2ca;width:35px}player-controls .player-action.active{color:#689f38}player-controls .player-action mat-icon{width:22px;height:22px}player-controls>player-seekbar{margin-left:20px}"];
export { styles as styles };
